<template>
  <section>
    <router-link
      :to="{name: 'DisasterNameManagement'}">
      Back
    </router-link>
    <h3>Add Disaster Name</h3>
    <b-field label="Code">
      <b-input v-model="form.code" placeholder="ex: DIS-233"/>
    </b-field>
    <b-field label="Year">
      <b-input v-model="form.year" placeholder="ex: 2012" type="number"/>
    </b-field>
    <b-field label="Name">
      <b-input v-model="form.name" placeholder="Disaster name"/>
    </b-field>
    <b-button
      @click="submit">
      Save
    </b-button>
  </section>
</template>
<script>
import {mapActions} from 'vuex'

export default {
  name: 'CreateDisasterName',
  data () {
    return {
      form: {
        code: '',
        year: 0,
        name: ''
      }
    }
  },
  methods: {
    ...mapActions('DisasterName',['create']),
    submit () {
      this.create(this.form)
        .then(() => {
          this.$router.replace({name: 'DisasterNameManagement'})
        })
        .catch(() => {
          alert('Create failed')
        })
    }
  }
}
</script>
